<div class="text-white text-xl mt-4">
  Creating an HD Wallet
</div>
<div class="my-4 bg-secondary rounded p-4 font-semibold text-white text-lg leading-snug">
  {{mnemonic$ | async}}
</div>
<div class="my-4 text-hint text-lg leading-snug">
  Write down the above mnemonic offline, and <span class="text-error font-semibold">keep it secret!</span> It is the only way you can recover your wallet if you lose it and anyone who gains access to it will be able to <span class="text-error font-semibold">steal all your keys</span>.
</div>